import React from "react";
import PropTypes from "prop-types";
import Table from "antd/lib/table";
import Icon from "antd/lib/icon";
import Button from "antd/lib/button";
import Slider from "antd/lib/slider";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import numeral from "numeral";

const ResultsTable = ({
  data = [],
  min = 0,
  max = 100,
  defaultValue = [20, 80],
  shouldShowSlider = false,
  sliderValues = [],
  sorter,
  output = [],
  onFilterChange = () => alert("onFilterChange is undefined"),
  onTableChange = () => alert("onTableChange is undefined"),
  onSelectOneRow = () => alert("onSelectOneRow is undefined"),
  onDeselectOneRow = () => alert("onDeselectOneRow is undefined"),
  onSelectAll = () => alert("onSelectAll is undefined"),
  onDeselectAll = () => alert("onDeselectAll is undefined"),
  onDiscardResult = () => alert("onDiscardResult is undefined")
}) => {
  const sliderProps = {
    range: true,
    defaultValue,
    min,
    max,
    onChange: values => onFilterChange(values),
    tipFormatter: value => numeral(sliderValues[value]).format("0.0a")
  };
  const sliderMin = sliderValues[0];
  const sliderMax = sliderValues[sliderValues.length - 1];
  const formattedMin = numeral(sliderMin).format("0.0a");
  const formattedMax = numeral(sliderMax).format("0.0a");
  const slider = shouldShowSlider ? (
    <div
      className="custom-filter-dropdown ant-table-filter-dropdown"
      style={{ minWidth: "20rem", padding: "0.5rem 1rem" }}
    >
      <Row>
        <Col span={4}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
              <strong>Min:</strong>
            </div>
            <div>{formattedMin}</div>
          </div>
        </Col>
        <Col span={16}>
          <Slider {...sliderProps} />
        </Col>
        <Col span={4}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
              <strong>Max:</strong>
            </div>
            <div>{formattedMax}</div>
          </div>
        </Col>
      </Row>
    </div>
  ) : (
    <div />
  );

  const columns = [
    {
      title: "Hashtag",
      dataIndex: "hashtag",
      key: "hashtag",
      width: "30%",
      render: x => `#${x}`
    },
    {
      title: "Count",
      width: "15%",
      dataIndex: "media_count",
      key: "media_count",
      sorter: (a, b) => a.media_count - b.media_count,
      sortOrder: sorter.order,
      filterDropdown: slider,
      render: count => numeral(count).format("0.0a")
    },
    {
      title: "Type",
      dataIndex: "icon",
      key: "icon",
      width: "15%",
      filters: [
        { text: "Inputs", value: "form" },
        // { text: "Favorites", value: "heart" },
        { text: "Search Results", value: "search" }
      ],
      onFilter: (value, record) => {
        return record.icon === value;
      },
      render: icon => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Icon type={icon} alt={icon} />
          </div>
        );
      }
    },
    {
      title: "Discard",
      width: "15%",
      render: row => (
        <Button icon="delete" onClick={() => onDiscardResult(row.hashtag)} />
      )
    }
  ];

  const tableProps = {
    size: "small",
    bordered: true,
    loading: false,
    pagination: { position: "bottom" },
    showHeader: true,
    rowKey: "hashtag",
    rowSelection: {
      onSelect: (record, selected, selectedRows, nativeEvent) => {
        const selectionHandler = selected ? onSelectOneRow : onDeselectOneRow;
        const { hashtag } = record;
        selectionHandler({ hashtag });
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        const selectionHandler = selected ? onSelectAll : onDeselectAll;
        const hashtags = changeRows.map(x => x.hashtag);
        selectionHandler({ hashtags });
      },
      selectedRowKeys: output
    },
    scroll: { x: true, y: 1440 },
    columns,
    dataSource: data,
    onChange: (pagination, filters, sorter) => {
      const { order, columnKey } = sorter;
      onTableChange({ order, columnKey });
    }
  };

  return (
    <div className="ResultsTableContainer">
      <Table {...tableProps} />
    </div>
  );
};

ResultsTable.propTypes = {
  onSelectOneRow: PropTypes.func.isRequired,
  onDeselectOneRow: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onDeselectAll: PropTypes.func.isRequired,
  onDiscardResult: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onTableChange: PropTypes.func.isRequired
};

export default ResultsTable;



// WEBPACK FOOTER //
// ./src/ResultsTable.js